import {
  Link,
  useNavigate,
  useSearchParams,
  useLocation,
} from 'react-router-dom';
import { MenuItem } from 'primereact/menuitem';
import { Sidebar } from 'primereact/sidebar';
import { ReactElement, useEffect, useState } from 'react';
import { TieredMenu } from 'primereact/tieredmenu';
import { useAuth0 } from '@auth0/auth0-react';
import { useCartContext } from 'CartContext';
// import { useMarketplaceDomain } from 'hooks/useMarketplace';
import { useLogin, useLogout } from 'hooks/userHooks';
import Nav from 'components/nav/Nav';
import './index.scss';
import FocusLock from 'react-focus-lock';
import { MegaMenu } from 'primereact/megamenu';
import useViewport from 'hooks/useViewport';
import { ThemeSwitch } from 'theme';
import useLocalStorage from 'utils/useLocalStorage';
import SearchMenu from 'components/search-menu';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { getMarketContent } from 'utils/marketContent';
import SummaryCard from './summary-card';

export default function ShopNavBar(): ReactElement {
  const [marketPlaceLogo, setMarketPlaceLogo] = useState<any>();
  const [marketPlaceLogoMobile, setMarketPlaceLogoMobile] = useState<any>();
  const { items, quantity, hideNav, setHideNav } = useCartContext();
  const [model, setModel] = useState<MenuItem[]>([]);
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split('/');
  const login = useLogin();
  const logout = useLogout();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const marketplaceDomain = useMarketplaceDomain();
  const [isDarkFromLocalStroage] = useLocalStorage<boolean>(
    'isDark',
    localStorage.getItem('isDark') === 'true',
  );
  const { isAuthenticated, user } = useAuth0();
  const { width } = useViewport();
  const isMobileWidth = width < 992;
  const [isMobile, setIsMobile] = useState(isMobileWidth);
  const [visibleCart, setCartVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const market = getMarketContent();
  const marketName = market.market;
  const data = market.navigation;

  if (marketName === 'crwdmarket') {
    return <Nav />;
  }

  useEffect(() => {
    if (isMobileWidth !== isMobile) {
      setIsMobile(isMobileWidth);
    } else {
      setCartVisible(false);
    }
  }, [width, isMobile, isMobileWidth]);

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', stickyCallBak);

    return () => {
      window.removeEventListener('scroll', stickyCallBak);
    };
  });

  /* Method that will fix header after a specific scrollable */
  const stickyCallBak = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 350 ? setIsScrolled(true) : setIsScrolled(false);
  };

  useEffect(() => {
    const searchEntries = Object.fromEntries(searchParams.entries());
    if (searchEntries['hide-nav']) {
      setHideNav(searchEntries['hide-nav'] === 'true');
    }
  }, [searchParams, setHideNav]);

  useEffect(() => {
    const marketPlaceLogoMobile = isDarkFromLocalStroage
      ? data.logoMobileLight
      : data.logoMobileDark;
    setMarketPlaceLogoMobile(marketPlaceLogoMobile);

    const marketPlaceLogo = isDarkFromLocalStroage
      ? data.logoDesktopLight
      : data.logoDesktopDark;
    setMarketPlaceLogo(marketPlaceLogo);
  }, [
    data.logoDesktopDark,
    data.logoDesktopLight,
    data.logoMobileDark,
    data.logoMobileLight,
    isDarkFromLocalStroage,
  ]);

  useEffect(() => {
    if (isAuthenticated) {
      setModel([
        ...MobileNavitems,
        {
          label: user?.name || user?.email || 'User',
          icon: 'pi pi-user',
          items: [
            {
              label: 'Orders',
              command: () => navigate('/orders'),
            },
            {
              label: 'Logout',
              command: () => logout(),
            },
          ],
          className: 'nav-email-item',
        },
      ]);
    } else {
      setModel([...MobileNavitems, ...loggedOutItems]);
    }
    // TODO: fix below
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const loggedInItems = [
    {
      label: user?.name || user?.email || 'User',
      icon: 'pi pi-user',
      className: 'nav-email-item',
      items: [
        {
          label: 'Orders',
          command: () => navigate('/orders'),
        },
        {
          label: 'Logout',
          command: () => logout(),
        },
      ],
    },
  ];

  const loggedOutItems = [
    {
      label: 'Login',
      icon: 'pi pi-user',
      command: () => login(),
    },
  ];
  if (hideNav) {
    return <></>;
  }

  // if (marketplaceDomain?.includes('blockchainecosystem')) {
  //   return <Nav />;
  // }

  const DesktopNavitems = data.navigationItemsDesktop?.map(item => ({
    label: item.label,
    ...(item.className && {
      className: splitLocation[1] === item.className ? 'active-route' : '',
    }),
    ...(item.url && {
      command: () => navigate(item.url),
    }),
    ...(item.items &&
      (item.label !== 'Portfolio'
        ? {
            items: [
              item.items?.map(subItem => ({
                label: subItem.label,
                ...(subItem.items && {
                  items: subItem.items?.map(innerItem => ({
                    label: innerItem.label,
                    command: () => navigate(innerItem.url),
                  })),
                }),
              })),
            ],
          }
        : {
            items: item.items?.map(portFolioItem => [
              {
                label: portFolioItem.label,
                items: portFolioItem.items?.map((item, itemIndex) =>
                  itemIndex === 0
                    ? {
                        label: item.label,
                        template: () => (
                          <Link
                            to={item.url}
                            className="p-megamenu-submenu-header--custom-link"
                          >
                            <h1 className="p-megamenu-submenu-header--custom-link">
                              {item.labelHeader}
                            </h1>
                          </Link>
                        ),
                      }
                    : {
                        label: item.label,
                        command: () => navigate(item.url),
                      },
                ),
              },
            ]),
          })),
  }));

  const MobileNavitems = data.navigationItemsMobile?.map(item => ({
    label: item.label,
    ...(item.url && {
      url: item.url,
    }),
  }));

  return (
    <>
      <nav
        className="store-nav-bar-wrapper"
        style={{ top: isScrolled ? '0' : '-225px' }}
      >
        <div className="StoreNavBar w-full">
          <div className="container">
            {isMobile ? (
              <>
                <div className="store-nav-mobile-menu py-4 px-2 flex justify-content-between mr-0 md:mr-2">
                  <div className="flex flex-direction-row justify-content-between align-items-center">
                    <Link to="/" className="mb-0 pb-0 pl-3">
                      <img
                        src={marketPlaceLogoMobile}
                        alt={marketName}
                        className="logo-mobile"
                        style={{ maxWidth: '70px', minWidth: '60px' }}
                      />
                    </Link>
                  </div>
                  <SearchMenu />
                </div>

                <div
                  className="nav-mobile-bottom fixed z-3 w-full flex justify-content-between align-items-center px-4 py-4"
                  style={{ backgroundColor: 'var(--surface-card)', bottom: 0 }}
                >
                  <Link to="/" className="mb-0 pb-0">
                    <i
                      className="pi pi-fw pi-home"
                      style={{ fontSize: '1.5em' }}
                    />
                  </Link>

                  <div style={{ marginBottom: '0.75rem' }}>
                    <ThemeSwitch />
                  </div>

                  <div className="mt-1 relative">
                    <div className="cart-wrapper">
                      <Button
                        icon="pi pi-shopping-cart"
                        className="border-noround p-button-outlined border-none p-button-secondary menu-bars"
                        onClick={() => setCartVisible(true)}
                      />
                      <span
                        className={`nav-cart-quantity ${
                          items.length === 0 ? 'cart-zero' : ''
                        }`}
                      >
                        {quantity}
                      </span>
                    </div>
                  </div>

                  <Button
                    icon="pi pi-bars"
                    className="border-noround p-button-outlined border-none p-button-secondary menu-bars"
                    onClick={() => setVisible(true)}
                  />
                </div>

                <Sidebar
                  visible={visibleCart}
                  position="bottom"
                  onHide={() => setCartVisible(false)}
                >
                  <FocusLock>
                    <SummaryCard />
                    <Button
                      icon="pi pi-times"
                      label="close summary"
                      className="uppercase border-noround p-button-outlined p-button-secondary ml-2 mt-8"
                      onClick={() => setCartVisible(false)}
                    />
                  </FocusLock>
                </Sidebar>

                <Sidebar
                  visible={visible}
                  position="bottom"
                  onHide={() => setVisible(false)}
                >
                  <FocusLock>
                    <div className="logo-wrapper col-6 pl-3">
                      <Link to="/">
                        <img
                          src={marketPlaceLogoMobile}
                          alt={marketName}
                          style={{ maxWidth: '70px', minWidth: '60px' }}
                        />
                      </Link>
                    </div>
                    <Menu model={model} />
                    <Button
                      icon="pi pi-times"
                      label="close menu"
                      className="uppercase border-noround p-button-outlined p-button-secondary ml-2"
                      onClick={() => setVisible(false)}
                    />
                  </FocusLock>
                </Sidebar>
              </>
            ) : (
              <div className="store-nav-middle flex">
                <div
                  className="grid py-2 w-full m-0"
                  style={{ alignItems: 'center' }}
                >
                  <SearchMenu />
                  <div className="logo-wrapper col-6">
                    <Link to="/">
                      <img src={marketPlaceLogo} alt={marketName} />
                    </Link>
                  </div>
                  <div className="col-3 relative flex flex-row offset-nav-items">
                    <div className="hidden lg:flex mr-1">
                      <ul className="wrapper my-0 ml-auto">
                        <TieredMenu
                          model={
                            isAuthenticated ? loggedInItems : loggedOutItems
                          }
                          className="user-info-menu ml-auto flex-column"
                        />
                      </ul>
                      <div className="my-1 mr-1">
                        <ThemeSwitch />
                      </div>
                    </div>
                    <SummaryCard />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <MegaMenu
          model={DesktopNavitems}
          className="store-nav-lower-mega hidden lg:flex"
        />
      </nav>
    </>
  );
}
